// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"src-components-atoms-icon-icon-module__icon-wrapper--qAaZS","iconWrapper":"src-components-atoms-icon-icon-module__icon-wrapper--qAaZS"};